/* tslint:disable */

// Borrowed these from office-online-ui/office-catchup-activity package.
// Link : https://office.visualstudio.com/DefaultCollection/OC/_git/office-online-ui?path=%2Fpackages%2Foffice-catchup-activity%2Fsrc%2Finfrastructure%2Fevent.ts&version=GBmaster&_a=contents

// An interface representing the slice of the Event<T> class needed to
// subscribe to / unsubscribe from an event.
export interface IEventListeners<TArgs> {
  addListener: (listener: (args: TArgs) => void) => void;
  removeListener: (listener: ((args: TArgs) => void)) => void;
  getListenerCount(): number;
}

// Event implementation.  Allows an object to notify subscribed listeners of an event, passing
// a typed payload for event arguments.  Users of this class should keep the Event<T> private,
// and instead expose the object to the outside via the IEventListeners<T> interface to
// prevent other classes from firing the event.
export class Event<T> implements IEventListeners<T> {
  private _listeners: Array<(args: T) => void> = [];

  public fireEvent(args: T): void {
    this._listeners.forEach(listener => listener(args));
  }

  public addListener(listener: (args: T) => void): void {
    if (listener) {
      this._listeners.push(listener);
    }
  }

  public removeListener(listener: ((args: T) => void)): void {
    this._listeners = this._listeners.filter(h => h !== listener);
  }

  public getListenerCount(): number {
    return this._listeners.length;
  }
}
